import { SEPARATOR, exactValidator, genericValidateName, uuidValidator } from './genericName';
import * as libHabitat from './habitat';
import * as libInvestor from './investor';
import * as libInvestorAccount from './investorAccount';
export const prefix = 'votingPolicySelection';
export const prefixWithSeparator = prefix + SEPARATOR;
export const IDToName = ({ habitatID, investorID, investorAccountID, investorAccountVotingPolicySelectionID, }) => {
    return (libInvestorAccount.IDToName({ habitatID, investorID, investorAccountID }) +
        SEPARATOR +
        prefixWithSeparator +
        investorAccountVotingPolicySelectionID);
};
export const validateName = genericValidateName([
    exactValidator(libHabitat.prefix),
    uuidValidator(),
    exactValidator(libInvestor.prefix),
    uuidValidator(),
    exactValidator(libInvestorAccount.prefix),
    uuidValidator(),
    exactValidator(prefix),
    uuidValidator(),
]);
export const nameToID = (name) => {
    validateName(name); // throws if invalid
    const parts = name.split('/');
    return {
        habitatID: parts[1],
        investorID: parts[3],
        investorAccountID: parts[5],
        investorAccountVotingPolicySelectionID: parts[7],
    };
};
